import axios from 'axios';
import { useQuery } from 'react-query';
import { NIL } from 'uuid';
import { CreateRecurringInvoiceInput } from './useRecurringRevenueCreate';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// dart (2026-07-14) — RNWY 2.0 #24. Fetches the server's pre-filled subscription-enrollment
// payload for an RNWY proposal (monthly lines linked to the locked SKUs + the customer's IO/PO
// reps at their v3 rate). Returns null when the deal has no recurring revenue (backend 204) — the
// enroll panel then renders nothing. The shape matches useRecurringRevenueCreate's input, so a
// confirmed payload POSTs straight to RecurringRevenue/Create.
const useRecurringProposal = (proposalId?: string) => useQuery(
  ['recurring-proposal', proposalId],
  async (): Promise<CreateRecurringInvoiceInput | null> => {
    const res = await axios.get(`${apiUrl()}proposal/${proposalId}/recurring-proposal`);
    if (res.status === 204 || !res.data) return null;
    return res.data as CreateRecurringInvoiceInput;
  },
  { enabled: !!proposalId && proposalId !== NIL, refetchOnWindowFocus: false },
);

export default useRecurringProposal;
